import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {CreateOrEditClient, PatchDaysToRetain} from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdateDaysToRetainOnClient() {
  const {enqueueSnackbar} = useSnackbar()

  const mutation = useMutation({
    mutationFn: async ({clientId, body}: {clientId: number; body: CreateOrEditClient}) => {
      const patchClient = new PatchDaysToRetain(clientId, body)
      await api.client.updateDaysToRetain(patchClient)
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos atualizar o cliente no momento')
    },
  })
  return mutation
}
